import React from 'react'

import {
  RadioGroup,
  StyledRadio,
  IconContainer,
  Label,
  RadioGroupIndicator,
  StyledRadioFlex,
} from './RadioMethodsSelection.styled'
import { RadioMethodsSelection, TagMethods } from './RadioMethodsSelection.models'

interface RadioBarProps {
  options: RadioMethodsSelection[]
  selectedValue: TagMethods
  onChange: (value: TagMethods) => void
}

export const RadioMethodSelection = ({ options, selectedValue, onChange }: RadioBarProps) => {
  return (
    <RadioGroup>
      {options.map((opt) => (
        <StyledRadioFlex
          onClick={() => onChange(opt.value)}
          active={selectedValue === opt.value}
          key={opt.value}
          htmlFor={opt.value}
        >
          <StyledRadio checked={selectedValue === opt.value} value={opt.value} id={opt.value}>
            <RadioGroupIndicator />
          </StyledRadio>
          <Label>{opt.label}</Label>
          <IconContainer>{opt.icon}</IconContainer>
        </StyledRadioFlex>
      ))}
    </RadioGroup>
  )
}
